/**
 * /tenants/{slug}/automation-accounts/new — tenant-scoped create.
 */

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CreateAutomationAccountPage } from "@/features/automation-accounts/pages/create-automation-account-page";

function TenantCreateAutomationAccountPage() {
  const { tenant } = Route.useRouteContext();
  const { slug } = Route.useParams();
  const navigate = useNavigate();
  return (
    <CreateAutomationAccountPage
      tenantID={tenant.id}
      scope="tenant"
      basePath={`/tenants/${slug}/automation-accounts`}
      onBackToList={() =>
        void navigate({
          to: "/tenants/$slug/automation-accounts",
          params: { slug },
        })
      }
    />
  );
}

export const Route = createFileRoute(
  "/_authed/tenants/$slug/automation-accounts/new",
)({
  component: TenantCreateAutomationAccountPage,
});
